import router from './router'
import store from './store'
import { createPermissionGuard } from './utils/permission-guard'
import {
    installChunkLoadRecovery,
    resetChunkLoadRecovery
} from '@/utils/page-load-recovery'

installChunkLoadRecovery(router)
router.beforeEach(createPermissionGuard(store))
router.afterEach(() => resetChunkLoadRecovery())
